export const authRoles = {
    sa: ['SA'],
    admin: ["SA",'ADMIN'],
    admin_store_manager: ['ADMIN', "STORE_MANAGER"],
}